import { ReactComponent as user } from './user.svg'
import { ReactComponent as users } from './users.svg'
import { ReactComponent as warning } from './warning.svg'
import { ReactComponent as searchFile } from './search_file.svg'
import { ReactComponent as iconEdit } from './icon_edit.svg'
import { ReactComponent as layerGroup } from './layer-group.svg'
import { ReactComponent as surgery } from './surgery.svg'
import { ReactComponent as microscope } from './microscope.svg'
import { ReactComponent as stethoscope } from './stethoscope.svg'
import { ReactComponent as erlenmeyerFlask } from './erlenmeyer-flask.svg'
import { ReactComponent as clipboardMedical } from './clipboard-medical.svg'
import { ReactComponent as xRay } from './x-ray.svg'
import { ReactComponent as syringe } from './syringe.svg'
import { ReactComponent as home } from './home.svg'
import { ReactComponent as notFound } from './not_found.svg'
import { ReactComponent as einsteinLogo } from './einstein_logo.svg'
import { ReactComponent as change } from './change.svg'
import { ReactComponent as arrowUp } from './arrow_up.svg'
import { ReactComponent as arrowDown } from './arrow_down.svg'
import { ReactComponent as arrowLeft } from './arrow_left.svg'
import { ReactComponent as baby } from './baby.svg'
import { ReactComponent as loading } from './loading.svg'
import { ReactComponent as chevronDown } from './chevron_down.svg'
import { ReactComponent as chevronLeft } from './chevron_left.svg'
import { ReactComponent as chevronRight } from './chevron_right.svg'
import { ReactComponent as chevronUp } from './chevron_up.svg'
import { ReactComponent as arrowUpRightFromSquare } from './arrow-up-right-from-square.svg'
import { ReactComponent as copy } from './copy.svg'
import { ReactComponent as copyAlt } from './copy-alt.svg'
import { ReactComponent as fileExport } from './file_export.svg'
import { ReactComponent as construction } from './construction.svg'
import { ReactComponent as hospitalBed } from './hospital_bed.svg'
import { ReactComponent as chevronsRight } from './chevrons-right.svg'
import { ReactComponent as chevronsLeft } from './chevrons-left.svg'
import { ReactComponent as covidVirus } from './covid-virus.svg'
import { ReactComponent as search } from './search.svg'
import { ReactComponent as circleExclamation } from './circle-exclamation.svg'
import { ReactComponent as cached } from './cached.svg'
import { ReactComponent as behaviorSleep } from './behavior-sleep.svg'
import { ReactComponent as behaviorHeartRate } from './behavior-heart-rate.svg'
import { ReactComponent as behaviorHeart } from './behavior-heart.svg'
import { ReactComponent as behaviorExercise } from './behavior-exercise.svg'
import { ReactComponent as singleTimeline } from './single-timeline.svg'
import { ReactComponent as foot } from './foot.svg'
import { ReactComponent as heart } from './heart.svg'
import { ReactComponent as eye } from './eye.svg'
import { ReactComponent as ear } from './ear.svg'
import { ReactComponent as refresh } from './refresh.svg'
import { ReactComponent as dots } from './dots.svg'
import { ReactComponent as birthMeasurement } from './birth_measurement.svg'
import { ReactComponent as fetalDiagnosis } from './fetal-diagnosis.svg'
import { ReactComponent as tongue } from './tongue.svg'
import { ReactComponent as feedback } from './feedback.svg'
import { ReactComponent as dataNotFound } from './data-not-found.svg'
import { ReactComponent as breast } from './breast.svg'
import { ReactComponent as hypodermicSyringe } from './hypodermic_syringe.svg'
import { ReactComponent as worksheets } from './worksheets.svg'
import { ReactComponent as medicalInformation } from './medical_information.svg'
import { ReactComponent as assistantChat } from './assistant_chat.svg'
import { ReactComponent as assistantLink } from './assistant_link.svg'
import { ReactComponent as pregnantWomanAndNewborn } from './pregnant_woman_and_newborn.svg'

// GOOGLE ICONS
import { ReactComponent as accountTree } from './account_tree.svg'
import { ReactComponent as analytics } from './analytics.svg'
import { ReactComponent as breastfeeding } from './breastfeeding.svg'
import { ReactComponent as contentPasteSearch } from './content_paste_search.svg'
import { ReactComponent as dataset } from './dataset.svg'
import { ReactComponent as dateRange } from './date_range.svg'
import { ReactComponent as pageInfo } from './page_info.svg'
import { ReactComponent as ribCage } from './rib_cage.svg'
import { ReactComponent as oncology } from './oncology.svg'
import { ReactComponent as science } from './science.svg'
import { ReactComponent as grain } from './grain.svg'
import { ReactComponent as stethoscopeThin } from './stethoscope_thin.svg'

// LIB ZERA ICONS
import { ReactComponent as attentionTriangle } from './attention_triangle.svg'
import { ReactComponent as checkRounded } from './check_rounded.svg'
import { ReactComponent as externalLink } from './external_link.svg'
import { ReactComponent as close } from './close.svg'
import { ReactComponent as load } from './load.svg'
import { ReactComponent as chevronUpDown } from './chevron_up_down.svg'

export const Icons = {
  user,
  users,
  warning,
  searchFile,
  iconEdit,
  microscope,
  stethoscope,
  erlenmeyerFlask,
  clipboardMedical,
  xRay,
  syringe,
  layerGroup,
  home,
  notFound,
  einsteinLogo,
  change,
  baby,
  loading,
  chevronDown,
  chevronLeft,
  chevronRight,
  chevronUp,
  arrowUp,
  arrowLeft,
  arrowDown,
  arrowUpRightFromSquare,
  copy,
  copyAlt,
  fileExport,
  surgery,
  construction,
  hospitalBed,
  chevronsRight,
  chevronsLeft,
  covidVirus,
  search,
  circleExclamation,
  cached,
  behaviorHeart,
  behaviorHeartRate,
  behaviorSleep,
  behaviorExercise,
  singleTimeline,
  foot,
  heart,
  eye,
  ear,
  refresh,
  dots,
  birthMeasurement,
  fetalDiagnosis,
  tongue,
  feedback,
  dataNotFound,
  accountTree,
  analytics,
  breastfeeding,
  contentPasteSearch,
  dataset,
  dateRange,
  pageInfo,
  ribCage,
  science,
  grain,
  stethoscopeThin,
  attentionTriangle,
  checkRounded,
  externalLink,
  close,
  load,
  chevronUpDown,
  oncology,
  breast,
  hypodermicSyringe,
  worksheets,
  medicalInformation,
  assistantChat,
  assistantLink,
  pregnantWomanAndNewborn
}

export type IconName = keyof typeof Icons
